import React from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import { useNavigate } from "react-router-dom";

import BackIcon from "../../../../assets/images/back-icon.png";
import EvolutionGames from "../../../../assets/images/provider/provider-logo-evolution.png";
import EzugiGames from "../../../../assets/images/provider/provider-logo-ezugi.png";
import AppuGames from "../../../../assets/images/provider/Supernowa2.jpg";
import LeftBarSports from "../../../components/LeftBarSports";
import { casinoTabs } from "../../../../lib/data";
import CasinoCard from "../../../components/CasinoCard";

const LiveDealer = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>

      <main className="main home-page d-flex">
        <LeftBarSports />

        <div className="middleContentSec">
          <div className="container">
            <div className="live-deal-section">
              <div className="headTitle mt-3">
                <div className="back-btn">
                  <a href="javascript:void(0)" onClick={() => navigate(-1)}>
                    <img src={BackIcon} alt="back" width={28} />
                  </a>
                </div>

                <div className="title">
                  <h3>Live Dealer</h3>
                </div>
              </div>
              <ul className="mt-3">
                {Array.isArray(Object.values(casinoTabs?.lobby)) &&
                  Object.values(casinoTabs?.lobby).map((game, idx) => (
                    <CasinoCard key={"casinogame" + idx} data={game} />
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </main>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default LiveDealer;
